import moment from 'moment'
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useMediaQuery } from 'react-responsive'
import { formatCurrency, formatCurrencyNoVnd } from '../../utils'
import http from '../../utils/http'
import CreateUpdateCardForm from './CreateUpdateCardForm'
import CardFilter from '../Filter/CardFilter'
import Header from '../Header/Header'

const ITEMS_PER_PAGE = 10

const CardDashboard = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const [currentPage, setCurrentPage] = useState(0)
  const [currentItems, setCurrentItems] = useState([])
  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [listKiosk, setListKiosk] = useState([])
  const [cards, setCards] = useState([])
  const [isShowCreatePopup,SetIsShowCreatePopUp] = useState(false)
  const [filteredTrans, setFilteredTrans] = useState([])

  const getSettings = async () => {
    try {
      const kiosktotal = sessionStorage.getItem('kioskTotal');
  
      if (kiosktotal) {
        const kiosks = [];
  
        for (let i = kiosktotal - 1; i >= 0; i--) {
          const kioskname = sessionStorage.getItem('kioskName' + i);
          const kioskId = sessionStorage.getItem('kioskId' + i);

          if (kioskname) {
            const kiosk = { kioskId: kioskId, kioskName: kioskname };
            kiosks.push(kiosk);
          }
        }
  
        setListKiosk(kiosks);
      }
  
      sessionStorage.setItem('transload', '0');
    } catch (error) {
      console.log('error: ', error);
    }
  };

  useEffect(() => {
    getSettings()
  }, [])

  const [filterCard, setFilterCard] = useState({
    licensePlate: '',
    paymentMethod: '',
    kioskId: '',
    startDate: null,
    employerId : '',
    cardId : '',
    endDate: null
  })

  const handleChangeFilterTransaction = (value) => {
    setFilterCard({
      ...filterCard,
      ...value
    })
  }

  const handleResetFilter = () => {
    setFilterCard({
      licensePlate: '',
      paymentMethod: '',
      kioskId: '',
      startDate: null,
      employerId : '',
      cardId : '',
      endDate: null
    })
  }

  const totalTransactions = cards.length

  const handlePageClick = (event) => {
    const newOffset = (event.selected * ITEMS_PER_PAGE) % totalTransactions
    setItemOffset(newOffset)
    setCurrentPage(event.selected)
  }

  useEffect(() => {
    const endOffset = itemOffset + ITEMS_PER_PAGE
    console.log("filter card ",filterCard)
    const filteredTransactions = cards
      .filter((card) => {
        if (filterCard.startDate) {
          return moment(card.checkInTime).isSameOrAfter(
            moment(new Date(filterCard.startDate).getTime()),
            'day'
          )
        }
        return true
      })
      .filter((card) =>{
        if(filterCard.department){
          return card.department === filterCard.department
        }
        return true
      })
      .filter((card) =>{
        if(filterCard.cardId){
          return card.cardId === filterCard.cardId
        }
        return true
      })
      .filter((card) => {
        if(filterCard.employerId){
          return card.userid === filterCard.employerId
        }
        return true
      })
      .filter((card) => {
        if (filterCard.endDate) {
          return moment(card.checkOutTime).isSameOrBefore(
            moment(new Date(filterCard.endDate).getTime()),
            'day'
          )
        }
        return true
      })
      .filter((card) => {
        if (filterCard.kioskId) {
          return card.kioskId === filterCard.kioskId
        }
        return true
      })
      .filter((card) => {
        if (filterCard.licensePlate) {
          return card.licensePlate === filterCard.licensePlate
        }
        return true
      })
      .filter((card) => {
        if (filterCard.paymentMethod) {
          return card.paymentMethod === filterCard.paymentMethod
        }
        return true
      })

    setFilteredTrans(filteredTransactions)
    setCurrentItems(filteredTransactions.slice(itemOffset, endOffset))

    setPageCount(Math.ceil(filteredTransactions.length / ITEMS_PER_PAGE))
  }, [cards, itemOffset, filterCard])

  useEffect(() => {
    setCurrentPage(0)
    setItemOffset(0)
  }, [filterCard])

  const getCard = async (kioskid) => {
    try {
      const getResp = await http.get('/cards/find-by-kioskid/'+kioskid)
      const cards = []
      if (getResp.data.length > 0) {
        getResp.data.forEach((element) => {
          cards.push(element)
          //setCards(prevCards => [...prevCards, element]);
        })
      }
      setCards(cards)
      console.log('getCard ',getResp.data)
    } catch (error) {
      console.log('error', error)
    }
  }

  const createCard = async (input) => {
    try {
        //Just choose first kiosk
        const kioskid = sessionStorage.getItem('kioskId' + 0) 
        
        const response = await http.post('/cards',{
            kioskId: kioskid,
            cardId : input.cardId,
            role : "STAFF",
            userid : input.userId,
            username : input.username,
            department : input.department
        })
        cards.push({
          kioskId: kioskid,
          cardId : input.cardId,
          role : "STAFF",
          userid : input.userId,
          username : input.username,
          department : input.department
        })
        setCards(cards)
    }catch (error){
        console.log('error', error)
    }
  }

  const updateCard = async (input)=>{
    try {
      //Just choose first kiosk
      const kioskid = sessionStorage.getItem('kioskId' + 0) 
      const body = {
        kioskId: kioskid,
        cardId : input.cardId,
        userId : input.userId,
        userName : input.username,
        department : input.department
      }
      console.log('update',JSON.stringify(body))
      const response = await http.put ('/cards/update-by-userid',body)
      window.location.reload();
      //getCard("no need to pass kioskid")
  }catch (error){
      console.log('error', error)
  }
  }

  useEffect(() => {
    ;(async () => {
      try {
        setCards([])
        //getCard("No need kiosk id")
        const kiosktotal = sessionStorage.getItem('kioskTotal')
        console.log('Kiosk total ',kiosktotal); 
        for (var i = 0; i < kiosktotal; i++) {
          const kioskid = sessionStorage.getItem('kioskId' + i)
          console.log('Get card from id',kioskid)
          getCard(kioskid)
        }
        cards.reverse();
      } catch (error) {
        console.log('error: ', error)
      }
    })()
  }, [])

  useEffect(() => {
    if (cards.length !== 0) {
      sessionStorage.removeItem('transload')
    }
  }, [cards])

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      {isMobile && <Header />}
      <div
        style={isMobile ? { marginTop: '55px' } : {}}
        className="post d-flex flex-column-fluid"
        id="kt_post"
      >
        <div id="kt_content_container" className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <div className="card card-xl-stretch mb-5 mb-xl-8">
                <div className="card-header border-0 pt-5">
                  <div className="w-100 card-title d-flex align-items-center justify-content-between">
                    <span className="card-label fw-bolder fs-3">NHÂN VIÊN</span>
                    <CardFilter
                      filterTransaction={filterCard}
                      onResetFilter={handleResetFilter}
                      onChangeFilterTransaction={handleChangeFilterTransaction}
                    />
                    <button
                        className="btn btn-success"
                        type="button"
                        onClick={(e) => {
                            SetIsShowCreatePopUp(true)
                        }}
                        >
                        Cập nhật Nhân viên
                    </button>
                  </div>
                </div>

                <div className="card-body py-3">
                  <div className="table-responsive">
                    <table className="table-card table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                      <thead>
                        <tr className="fw-bolder text-muted">
                          <th className="min-w-100px text-center">STT</th>
                          <th className="min-w-100px text-center">
                            Số Máy
                          </th>
                          <th className="min-w-100px text-center">
                           Phòng ban
                          </th>
                          <th className="min-w-100px text-center">
                            Mã Thẻ
                          </th>
                          <th className="min-w-100px text-center">
                            Mã Nhân viên
                          </th>

                          <th className="min-w-150px text-center">Họ và tên</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((card, index) => (
                          <tr key={itemOffset + index +1}>
                            {/* STT */}
                            <td className="text-center">
                              <span className="text-dark d-block fs-6">
                                {itemOffset + index + 1}
                              </span>
                            </td>
                            {/* Số Máy */}                            
                            <td className="text-center">
                              {
                                listKiosk.find(
                                  (kiosk) =>
                                    kiosk.kioskId === card.kioskId
                                )?.kioskName
                              }
                            </td>
                            {/* Phòng ban */}                                                        
                            <td className="text-center">
                              <div className="d-flex align-items-center justify-content-center">
                                <span className="mx-3 fw-bold text-dark d-block fs-6">
                                  {card.department}
                                </span>
                              </div>
                            </td>

                            {/* Mã thẻ */}                                                        
                            <td className="text-center">
                              <div className="d-flex align-items-center justify-content-center">
                                <span className="mx-3 fw-bold text-dark d-block fs-6">
                                  {card.cardId}
                                </span>
                              </div>
                            </td>

                            {/* Mã nv */}                                                        
                            <td className="text-center">
                              <div className="d-flex align-items-center justify-content-center">
                                <span className="mx-3 fw-bold text-dark d-block fs-6">
                                  {card.userid}
                                </span>
                              </div>
                            </td>
     
                            {/* Họ tên */} 
                            <td className="text-center">
                              <div className="d-flex align-items-center justify-content-center">
                                <span className="mx-3 fw-bold text-dark d-block fs-6">
                                  {card.username}
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
        {isShowCreatePopup && ( 
            <CreateUpdateCardForm 
                allCard={cards}
                onFormClose={ () => {
                    SetIsShowCreatePopUp(false)
                }}
                onFormSubmit={(data) => {
                    SetIsShowCreatePopUp(false)
                    console.log('submit form',data)
                    if(data.type == "create"){
                      createCard(data)
                    }
                    if(data.type == "update"){
                      updateCard(data)
                    }
                }}
            />
        )};

      <ReactPaginate
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="<"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={currentPage}
      />

    </div>
  )
}

export default CardDashboard
